import { useState, useEffect } from "react";

export const useScrollDetector = () => {
    const [top, setTop] = useState(true);
    useEffect(() => {
        window.onscroll = () => {
            window.scrollY !== 0 ? setTop(false) : setTop(true);
        }
        return () => {
            window.onscroll = null;
        };
    });
    return (top);
}
